function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.878 10.816v5.569h7.912c.968 0 1.753.786 1.753 1.752v12.299c0 .967-.784 1.752-1.753 1.752H11.21a1.753 1.753 0 01-1.753-1.752v-12.3c0-.967.784-1.751 1.753-1.751h7.912v-5.572l-2.132 2.132a.879.879 0 01-1.242-1.242l3.635-3.636a.865.865 0 01.613-.255l.007.003c.223 0 .444.085.611.252l1.248 1.248 2.388 2.387c.34.34.34.892-.006 1.237a.879.879 0 01-1.236.006l-2.13-2.129zm-1.756 7.326h-7.908V30.43h17.571V18.142h-7.907v2.85a.878.878 0 01-1.757 0v-2.85zm-5.272-1.757v1.757h12.3v-1.757h-12.3zm5.272 0h1.756v1.757h-1.756v-1.757z",
    fill: props.color
  }));
}

export default SvgIconShare;